var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-row flex-grow-1"},_vm._l((_vm.count),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"d-flex flex-column flex-grow-1",class:_vm.classes,attrs:{"type":_vm.type}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }